import { render, staticRenderFns } from "./TSiteStaticip.vue?vue&type=template&id=163ed17c&"
import script from "./TSiteStaticip.vue?vue&type=script&lang=js&"
export * from "./TSiteStaticip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports